import { Clock, Calendar, Baby, Palette, Music, Puzzle } from "lucide-react";

const activities = [
  { icon: Music, label: "Songs & Rhymes", color: "text-brand-red" },
  { icon: Palette, label: "Arts & Crafts", color: "text-brand-green" },
  { icon: Puzzle, label: "Puzzles & Play", color: "text-brand-yellowDark" },
  { icon: Baby, label: "Story Circle", color: "text-brand-purple" },
];

export default function Programme() {
  return (
    <section id="programme" className="relative py-20 md:py-28 bg-brand-cream" data-testid="programme-section">
      <div className="mx-auto max-w-6xl px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="uppercase tracking-widest text-sm font-bold text-brand-green">Our Programme</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold text-brand-ink">
            Three joyful mornings, <span className="text-brand-red">every week.</span>
          </h2>
          <p className="mt-4 text-lg text-brand-ink/80">
            Structured play, gentle routine and lots of giggles. Designed for curious 3–4 year olds.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          <div className="rounded-3xl border-[3px] border-brand-ink bg-white p-8 shadow-brutal-sm relative overflow-hidden">
            <div className="absolute -right-6 -top-6 w-24 h-24 bg-brand-yellow/50 rounded-full" />
            <div className="relative">
              <div className="w-12 h-12 rounded-2xl bg-brand-yellow border-2 border-brand-ink flex items-center justify-center">
                <Calendar size={22} strokeWidth={2.5} />
              </div>
              <h3 className="mt-4 font-display text-2xl font-semibold">When we meet</h3>
              <ul className="mt-3 space-y-1.5 font-bold text-brand-ink">
                <li className="flex justify-between"><span>Tuesday</span> <span className="text-brand-red">9am – 12pm</span></li>
                <li className="flex justify-between"><span>Wednesday</span> <span className="text-brand-red">9am – 12pm</span></li>
                <li className="flex justify-between"><span>Thursday</span> <span className="text-brand-red">9am – 12pm</span></li>
              </ul>
            </div>
          </div>

          <div className="rounded-3xl border-[3px] border-brand-ink bg-white p-8 shadow-brutal-sm relative overflow-hidden">
            <div className="absolute -right-6 -top-6 w-24 h-24 bg-brand-green/40 rounded-full" />
            <div className="relative">
              <div className="w-12 h-12 rounded-2xl bg-brand-green border-2 border-brand-ink flex items-center justify-center">
                <Clock size={22} strokeWidth={2.5} className="text-white" />
              </div>
              <h3 className="mt-4 font-display text-2xl font-semibold">Session length</h3>
              <p className="mt-3 font-bold text-brand-ink">3 hours of guided play</p>
              <p className="text-sm text-brand-ink/70 mt-2 leading-relaxed">
                A perfect first taste of school-day rhythm — with plenty of hugs, snack time and outdoor fun.
              </p>
            </div>
          </div>

          <div className="rounded-3xl border-[3px] border-brand-ink bg-white p-8 shadow-brutal-sm relative overflow-hidden">
            <div className="absolute -right-6 -top-6 w-24 h-24 bg-brand-red/30 rounded-full" />
            <div className="relative">
              <div className="w-12 h-12 rounded-2xl bg-brand-red border-2 border-brand-ink flex items-center justify-center">
                <Baby size={22} strokeWidth={2.5} className="text-white" />
              </div>
              <h3 className="mt-4 font-display text-2xl font-semibold">Ages we love</h3>
              <p className="mt-3 font-bold text-brand-ink">3 to 4 years old</p>
              <p className="text-sm text-brand-ink/70 mt-2 leading-relaxed">
                Little explorers ready to socialise, discover and start their learning journey.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-3xl border-[3px] border-brand-ink bg-white p-8 shadow-brutal-sm">
          <h3 className="font-display text-2xl font-semibold text-brand-ink">A typical morning</h3>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            {activities.map((a) => {
              const Icon = a.icon;
              return (
                <div key={a.label} className="text-center p-4 rounded-2xl bg-brand-cream border-2 border-brand-ink lift-hover" data-testid={`activity-${a.label.toLowerCase().replace(/\s|&/g, "")}`}>
                  <Icon size={36} strokeWidth={2.5} className={`mx-auto ${a.color}`} />
                  <p className="mt-2 font-display font-semibold">{a.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
